var map = {
	"./ImageEmptyConnectable.svg": 77041,
	"./ImageEmptyIntra.svg": 40283,
	"./LogoDots.svg": 49710,
	"./MainLogo.svg": 17953,
	"./MainLogoLight.svg": 12231,
	"./VideoPoster2.svg": 50223,
	"./VideoPosterConn.svg": 31437,
	"./VideoPosterIntra.svg": 64141,
	"./VideoPoster_disabled.svg": 91266,
	"./access_all.svg": 42009,
	"./access_city.svg": 3349,
	"./access_department.svg": 39514,
	"./access_head.svg": 12518,
	"./access_manual.svg": 40930,
	"./access_name.svg": 54521,
	"./access_time.svg": 53643,
	"./alert_icon_error.svg": 53086,
	"./alert_icon_info.svg": 35688,
	"./alert_icon_question.svg": 50312,
	"./alert_icon_success.svg": 50733,
	"./alert_icon_warning.svg": 7400,
	"./b24_angry.svg": 44767,
	"./b24_facepalm.svg": 62331,
	"./b24_haha.svg": 60368,
	"./b24_like.svg": 53065,
	"./b24_love.svg": 28984,
	"./b24_sad.svg": 93628,
	"./b24_wow.svg": 66577,
	"./dots.svg": 77663,
	"./empties/empty_address_book.svg": 91599,
	"./empties/empty_groups.svg": 19547,
	"./empties/empty_kb.svg": 23076,
	"./empties/empty_polls.svg": 48935,
	"./empties/empty_services.svg": 76899,
	"./empties/empty_vacancies.svg": 75606,
	"./intranetable_logo.svg": 11880,
	"./intranetable_logo_bord.svg": 66320,
	"./sendsay.svg": 53074,
	"./sendsay_logo.svg": 64687,
	"./ya-music-ru-white_v2023.svg": 3699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;